import type {ReferralProgramActions} from 'src/action-creators/referral-v2/programs';

import type {
  Programs,
  GenericError,
  ProgramJobCount,
  ReferralSetup,
  ReferralBonusAndPayoutSettings,
} from 'src/types/referral-v2';
import {
  INITIAL_SETUP_STATE,
  INITIAL_REFERRAL_SETTINGS,
} from 'src/utils/referral-v2';
import {
  PROGRAM_DETAILS_FORM_DATA,
  ACTIVE_PROGRAMS,
  INACTIVE_PROGRAMS,
  PROGRAMS_ERROR,
  PROGRAMS_LOADING,
  PROGRAM_JOBS_COUNT,
  PROGRAM_JOBS_COUNT_ERROR,
} from 'src/action-creators/referral-v2/programs';


export const loadingState = {
  IDLE: 'idle',
  FETCHING_PROGRAMS: 'fetchingPrograms',
} as const;

const initialState = {
  active_programs: null,
  inactive_programs: null,
  programs_error: null,
  current_state: loadingState.IDLE,
  program_job_count: null,
  program_job_count_error: null,
  program_details_form_data: {
    setup: INITIAL_SETUP_STATE,
    bonus_and_payout_settings:
      INITIAL_REFERRAL_SETTINGS.bonus_and_payout_settings,
  },
} as const;

type ReferralProgramState = {
  current_state?: string | null | undefined;
  active_programs?: Programs | null | undefined;
  inactive_programs?: Programs | null | undefined;
  programs_error?: GenericError | null | undefined;
  program_details_form_data: {
    setup: ReferralSetup;
    bonus_and_payout_settings: ReferralBonusAndPayoutSettings;
  };
  program_job_count?: ProgramJobCount | null | undefined;
  program_job_count_error?: GenericError | null | undefined;
};

export default (
  state: ReferralProgramState | null | undefined = initialState,
  action: ReferralProgramActions,
): ReferralProgramState => {
  switch (action.type) {
    case ACTIVE_PROGRAMS:
      // @ts-expect-error - TS2322 - Type '{ active_programs: Programs | null | undefined; programs_error: null; current_state: "idle"; inactive_programs?: Programs | null | undefined; program_details_form_data?: { ...; } | undefined; program_job_count?: ProgramJobCount | null | undefined; program_job_count_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralProgramState'.
      return {
        ...state,
        active_programs: action.payload,
        programs_error: null,
        current_state: loadingState.IDLE,
      };
    case INACTIVE_PROGRAMS:
      // @ts-expect-error - TS2322 - Type '{ inactive_programs: Programs | null | undefined; programs_error: null; current_state: "idle"; active_programs?: Programs | null | undefined; program_details_form_data?: { ...; } | undefined; program_job_count?: ProgramJobCount | null | undefined; program_job_count_error?: GenericError | null | undefined; }' is not assignable to type 'ReferralProgramState'.
      return {
        ...state,
        inactive_programs: action.payload,
        programs_error: null,
        current_state: loadingState.IDLE,
      };
    case PROGRAMS_ERROR:
      // @ts-expect-error - TS2322 - Type '{ programs_error: GenericError | null | undefined; current_state: "idle"; active_programs?: Programs | null | undefined; inactive_programs?: Programs | null | undefined; program_details_form_data?: { ...; } | undefined; program_job_count?: ProgramJobCount | null | undefined; program_job_count_error?: GenericError | ...' is not assignable to type 'ReferralProgramState'.
      return {
        ...state,
        programs_error: action.payload,
        current_state: loadingState.IDLE,
      };
    case PROGRAMS_LOADING:
      // @ts-expect-error - TS2322 - Type '{ current_state: "fetchingPrograms"; active_programs?: Programs | null | undefined; inactive_programs?: Programs | null | undefined; programs_error?: GenericError | null | undefined; program_details_form_data?: { ...; } | undefined; program_job_count?: ProgramJobCount | null | undefined; program_job_count_error?: Ge...' is not assignable to type 'ReferralProgramState'.
      return {...state, current_state: loadingState.FETCHING_PROGRAMS};

    // @ts-expect-error - TS2678 - Type '"referral/program-jobs-count"' is not comparable to type '"referral/active-programs" | "referral/programs-loading" | "referral/programs-error" | "referral/inactive-programs" | "referral/agency-links" | "referral/agency-links-error" | ... 13 more ... | "referral/program-details-form-data"'.
    case PROGRAM_JOBS_COUNT:
      // @ts-expect-error - TS2322 - Type '{ program_job_count: any; program_job_count_error: null; current_state: "idle"; active_programs?: Programs | null | undefined; inactive_programs?: Programs | null | undefined; programs_error?: GenericError | null | undefined; program_details_form_data?: { ...; } | undefined; }' is not assignable to type 'ReferralProgramState'.
      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        program_job_count: action.payload,
        program_job_count_error: null,
        current_state: loadingState.IDLE,
      };

    // @ts-expect-error - TS2678 - Type '"referral/program-jobs-count-error"' is not comparable to type '"referral/active-programs" | "referral/programs-loading" | "referral/programs-error" | "referral/inactive-programs" | "referral/agency-links" | "referral/agency-links-error" | ... 13 more ... | "referral/program-details-form-data"'.
    case PROGRAM_JOBS_COUNT_ERROR:
      // @ts-expect-error - TS2322 - Type '{ program_job_count_error: any; current_state: "idle"; active_programs?: Programs | null | undefined; inactive_programs?: Programs | null | undefined; programs_error?: GenericError | null | undefined; program_details_form_data?: { ...; } | undefined; program_job_count?: ProgramJobCount | null | undefined; }' is not assignable to type 'ReferralProgramState'.
      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        program_job_count_error: action.payload,
        current_state: loadingState.IDLE,
      };
    case PROGRAM_DETAILS_FORM_DATA:
      return {
        ...state,
        program_details_form_data: action.payload,
        current_state: loadingState.IDLE,
      };

    default:
      // @ts-expect-error - TS2322 - Type '{ current_state?: string | null | undefined; active_programs?: Programs | null | undefined; inactive_programs?: Programs | null | undefined; programs_error?: GenericError | null | undefined; program_details_form_data?: { ...; } | undefined; program_job_count?: ProgramJobCount | null | undefined; program_job_count_er...' is not assignable to type 'ReferralProgramState'.
      return {...state};
  }
};
